/**
 * Featured Icons Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly coupled to the Featured Icons Section.
 */

 import {register} from '@shopify/theme-sections';
 import Flickity from 'flickity';

 export default register('featured-icons', {
   onLoad() {
    const featuredIconsSlider = this.container.querySelector('[data-icons-slider]');
    if (!featuredIconsSlider) return;

    const controls = this.container.querySelector('[data-featured-icons-controls]');
    const nextButton = controls.querySelector('.btn--control-next');
    const previousButton = controls.querySelector('.btn--control-prev');
    const carouselStatus = controls.querySelector('.carousel-status');

    const slider = new Flickity(featuredIconsSlider, {
      draggable: '>1',
      freeScroll: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'center',
      contain: true,
      watchCSS: true,
      wrapAround: true,
      on: {
        change() {
          const slideNumber = slider.selectedIndex + 1;
          carouselStatus.textContent = `0${slideNumber} / ${slider.slides.length < 10 ? '0' : ''}${slider.slides.length}`;
        }
      }
    });

    previousButton.addEventListener('click', function () {
      slider.previous();
    });

    nextButton.addEventListener('click', function () {
      slider.next();
    });

   },
 });
